var _excluded = ["helpText", "errorMsg", "maxChars", "minChars", "onlyShowMsgOnError", "l10n", "lingua"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormTextArea from './FormTextArea';
import FormUtil from './FormUtil';
import FormHelpBlock from './FormHelpBlock';
import "./FormTextAreaMinMax.css";

var FormTextAreaMinMax = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FormTextAreaMinMax, _PureComponent);

  function FormTextAreaMinMax(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _this.handleFocus = function (event) {
      if (!_this.state.hasFocus) {
        _this.setState({
          hasFocus: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.state.hasFocus) {
        _this.setState({
          hasFocus: false,
          hasBeenBlurred: true
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.state = {
      hasBeenBlurred: false
    };
    return _this;
  }

  var _proto = FormTextAreaMinMax.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        helpText = _this$props.helpText,
        errorMsg = _this$props.errorMsg,
        maxChars = _this$props.maxChars,
        minChars = _this$props.minChars,
        onlyShowMsgOnError = _this$props.onlyShowMsgOnError,
        l10n = _this$props.l10n,
        lingua = _this$props.lingua,
        rest = _objectWithoutProperties(_this$props, _excluded);

    var _this$state = this.state,
        hasFocus = _this$state.hasFocus,
        hasBeenBlurred = _this$state.hasBeenBlurred; // Should be removed when we remove the lingua prop

    var translations = lingua ? lingua : l10n;
    var id = this.props.id; // note that below, the disabled and value props have not been destructured since they need
    // to get passed through with ...rest to the input element to be used as an attribute

    var helpBlockValues = FormUtil.computeHelpValues({
      id: id,
      disabled: this.props.disabled,
      value: this.props.value,
      helpText: helpText,
      errorMsg: errorMsg,
      onlyShowMsgOnError: onlyShowMsgOnError,
      maxChars: maxChars,
      minChars: minChars,
      translations: translations,
      hasBeenBlurred: hasBeenBlurred,
      hasFocus: hasFocus,
      inverse: this.props.inverse
    });
    var maxCharCountExceeded = helpBlockValues.maxCharCountExceeded,
        hasError = helpBlockValues.hasError;
    var parentClasses = classNames('FormTextAreaMinMax', {
      'has-error': hasError,
      'has-focus': hasFocus
    });

    var textAreaProps = _extends({
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, FormUtil.needAriaMsg({
      errorMsg: errorMsg,
      helpText: helpText,
      minChars: minChars,
      maxCharCountExceeded: maxCharCountExceeded
    }) && {
      'aria-describedby': FormUtil.computeAriaMsgList({
        id: id,
        errorMsg: errorMsg,
        helpText: helpText,
        minChars: minChars,
        maxCharCountExceeded: maxCharCountExceeded
      })
    }, rest);

    return /*#__PURE__*/React.createElement("div", {
      className: parentClasses
    }, /*#__PURE__*/React.createElement(FormTextArea, textAreaProps), /*#__PURE__*/React.createElement(FormHelpBlock, helpBlockValues));
  };

  return FormTextAreaMinMax;
}(PureComponent);

FormTextAreaMinMax.displayName = 'FormTextAreaMinMax';
FormTextAreaMinMax.propTypes = {
  /** The textarea's id, required for a11y */
  id: PropTypes.string.isRequired,

  /** The textarea's label, required for a11y */
  label: PropTypes.string.isRequired,

  /** The actual content of the textarea */
  value: PropTypes.string,

  /** The height, in number of lines, to make the textarea. This is also the minimum size for autoExpand textareas */
  rows: PropTypes.number,

  /** A flag to make the textarea control expand its height to fit the content */
  autoExpand: PropTypes.bool,

  /** The height as a string, in a CSS unit (px, em, vh...) to limit the textarea's height. Can be left blank, zero, or negative for no limit. */
  maxHeight: PropTypes.string,

  /** The maximum height, in number of lines, to make the textarea. This will be trumped by maxHeight */
  maxRows: PropTypes.number,

  /** For form controls with no visible label, set this to true. Make sure to still add a value to the label property. For screen readers. */
  srOnlyLabel: PropTypes.bool,

  /** The help message displayed beneath the input. */
  helpText: PropTypes.node,

  /** The error message displayed beneath the input. Styling of the input will visually indicate an error state. */
  errorMsg: PropTypes.node,

  /** Flag to make helpText and errorMsg use white text for better a11y contrast when used on dark backgrounds */
  inverse: PropTypes.bool,

  /** Called when the value property changes */
  onChange: PropTypes.func,

  /** Called when the textarea gains focus */
  onFocus: PropTypes.func,

  /** Enables character counter and sets maximum count (0 indicates no maximum and will not enable count display)*/
  maxChars: PropTypes.number,

  /** Enables character counter and sets minimum count (0 indicates no minimum and will not enable count display)*/
  minChars: PropTypes.number,

  /** Flag when set to true will only render character count related messages when there is a character count error state*/
  onlyShowMsgOnError: PropTypes.bool,

  /** Prop to support localization of the string being used to communicate character count. It supports interpolation by replacing {minChars} or {maxChars}. */
  l10n: PropTypes.shape({
    minCharMessage: PropTypes.string,
    minCharErrorMessage: PropTypes.string,
    maxCharErrorMessage: PropTypes.string
  }),

  /** Deprecated - Prop to support localization of the string being used to communicate character count. It supports interpolation by replacing {minChars} or {maxChars}. */
  lingua: PropTypes.shape({
    minCharMessage: PropTypes.string,
    minCharErrorMessage: PropTypes.string,
    maxCharErrorMessage: PropTypes.string
  })
};
FormTextAreaMinMax.defaultProps = {
  autoExpand: false,
  srOnlyLabel: false,
  onlyShowMsgOnError: false,
  maxChars: 0,
  minChars: 0,
  l10n: {
    minCharMessage: '{minChars} character minimum',
    minCharErrorMessage: 'Characters remaining: {minChars}',
    maxCharErrorMessage: 'Over character limit'
  }
};
export default FormTextAreaMinMax;
//# sourceMappingURL=FormTextAreaMinMax.js.map